import { useCallback } from "react";
import { useDispatch, useSelector } from "@/lib/redux/store";
import { addFavoriteMatch, removeFavoriteMatch } from "@/lib/redux/actions/favoriteAction";

export function useMatchFavorite(match) {
  const dispatch = useDispatch();
  const favoriteMatches = useSelector((state) => state.favoriteReducer?.favoriteMatches ?? []);

  const matchId = match?.id;
  const isFavorite = matchId != null && favoriteMatches.some((m) => String(m.id) === String(matchId));

  const toggleFavorite = useCallback(() => {
    if (matchId == null) return;
    if (isFavorite) {
      dispatch(removeFavoriteMatch(matchId));
    } else if (match) {
      dispatch(addFavoriteMatch(match));
    }
  }, [dispatch, matchId, isFavorite, match]);

  return { isFavorite: !!isFavorite, toggleFavorite };
}
